define(function(require) {
    return {
        parseResponse:function(response){
			let token = '';
			let ret = {};
			if (typeof response === 'object' && response != null && response.responseJSON!= null && response.responseJSON.data!=null) {
				token = response.responseJSON.data.mfaToken;
				ret = response.responseJSON.data;
			
				ret.factor = this.parseJWT(token);
			}  else {
				//we should never be here...
				console.log('Error parsing JWT token.')
			}
			return ret;
		},
		//parses the JSON data out of the JWT token string received from the auth and MFA Subscription rest services.
		//can handle the string or the whole response.
		parseJWT : function (token)  {//response can be the response from the server, or the token itself.

			if (token && token.trim().length > 0) {
				// from https://stackoverflow.com/questions/38552003/how-to-decode-jwt-token-in-javascript-without-using-a-library
				var base64Url = token.split('.')[1];
				var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
				var jsonPayload = decodeURIComponent(window.atob(base64).split('').map(function (c) {
					return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
				}).join(''));

				return JSON.parse(jsonPayload);
			}
			return null;
		},
		getReasonFromResponse: function(response) {
			let ret = '';
			//we really need to get optional chaining working.
			if(response &&
				response.responseJSON && 
				response.responseJSON.data &&  
				response.responseJSON.data.mfaStatus){
				ret = response.responseJSON.data.mfaStatus.trim().toLowerCase();
			}
			return ret;
		},
		handleErrorResponse: function(response, view, codeType) {
			const ViewManager = require('civicsUtils/view_manager');
			const ccn = require('../core_constants');
			ViewManager.loading(false);
			let reason = this.getReasonFromResponse(response);
			// possible codes:
			// InvalidCode
			// InvalidCodeLastAttempt
			// AttemptExceeded
			// NoSecurityCode
			let preventFurtherAttempts = true;
			let preventReason = ccn.GENERALERROR;
			let errorText = i18n.t('CIVICS.LOGIN.FACTOR_AUTH.GENERAL_AUTHENTICATION_FAILURE');
			if(reason == ccn.INVALIDCODE){
				preventFurtherAttempts = false;
				preventReason = reason;
				errorText = i18n.t('CIVICS.LOGIN.FACTOR_AUTH.INVALID_CODE')
			}else if(reason == ccn.INVALIDCODELASTATTEMPT){
				preventFurtherAttempts = false;
				preventReason = reason;
				errorText = i18n.t('CIVICS.LOGIN.FACTOR_AUTH.INVALID_CODE');
				//for verification we do not lock the user out, so just show invalid code.
				errorText += codeType == ccn.VERIFICATION ? '' : ' '+i18n.t('CIVICS.LOGIN.FACTOR_AUTH.INVALID_CODE_LAST_ATTEMPT')
			} else if(reason == ccn.ATTEMPTEXCEEDED){
				preventReason = reason;
				errorText = i18n.t('CIVICS.LOGIN.FACTOR_AUTH.ATTEMPT_EXCEEDED')
			}else if(reason == ccn.NOSECURITYCODE){
				preventReason = reason;
				errorText = i18n.t('CIVICS.LOGIN.FACTOR_AUTH.NO_SECURITY_CODE')
			}
			if(preventFurtherAttempts){
				if (view.cancelLogin) {
					view.cancelLogin(preventReason);
				}
			} else {
				var errorObj = {
					authenticationCode:errorText
				};
				ViewManager.errorToWindow({
					validationError: errorObj
				}, view);
				if (view.ui && view.ui.submitButton) {
					view.ui.submitButton.prop('disabled',false);
				}
			}
		},
		getAuthenticationCode: function(view) {
			const ViewManager = require('civicsUtils/view_manager');
			if(ViewManager.validatePageControl(view.$el)) {
				let data = Backbone.Syphon.serialize(view.$el);
				return data;
			}
			return null;
		}
	};
});